import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string, number } from 'yup';

import Cabecalho from 'Component/Admin/Cabecalho';
import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Categoria from 'Interface/Categorias';
import { useAdicionarPlanoMutation } from 'Service';

const regras = object({
    nome: string().required('Obrigatório'),
    valor: number()
        .positive('Deve ser positivo')
        .required('Obrigatório'),
});

const Adicionar = (): React.ReactElement =>
{
    const navegacao = useNavigate();
    const toast = useToast();
    const [ adicionarPlano ] = useAdicionarPlanoMutation();

    const enviar = async (dados: Categoria): Promise<void> =>
    {
        try {
            await adicionarPlano(dados).unwrap();

            toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

            navegacao('/admin/planos');
        } catch (error) {
            toast({
                titulo: 'Erro ao alterar',
                conteudo: 'Verifique os logs para maiores detalhes.',
                tema: 'danger',
            });
        }
    }

    return (
        <div className="animate__animated animate__fadeIn">
            <Cabecalho
                titulo="Adicionando plano"
                descricao="Preencha o formulário e clique em enviar para cadastrar um novo plano"
            />
            <Form onSubmit={ enviar } regras={ regras }>
                <div className="row justify-content-center">
                    <div className="col-md-4">
                        <div className="bg-white shadow-sm rounded p-4">
                            <Campo name="nome" rotulo="Nome" />
                            <Campo
                                name="valor"
                                rotulo="Valor"
                                prefixar={ <Icone nome="currency-dollar" /> }
                            />
                            <div className="mt-5">
                                <Botao>Enviar</Botao>
                                <BotaoLink tema="light" to="/admin/planos" className="ms-2">
                                    Cancelar
                                </BotaoLink>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </div>
    )
}

export default Adicionar;
